import { QDialog as e, QIcon as t, QInput as n } from "quasar";
import { computed as r, createBlock as i, createElementBlock as a, createVNode as o, defineAsyncComponent as s, defineComponent as c, mergeProps as l, onBeforeMount as u, openBlock as d, ref as f, unref as p, watch as m, withCtx as h } from "vue";
import { useI18n as g } from "vue-i18n";
import { BfJobSelector as _, JobGroupModelName as v, JobService as y, JobService as b, getJob as x, getJobs as S } from "@modules/job-editor-ui-components";
import { isDocumentEditable as C } from "@editor/ui-utils";
//#endregion
//#region src/lang/index.ts
var w = {
	en: {
		jobs: {
			jobId: "Team ID",
			job: "Team",
			displayName: "Display name",
			lastChange: "Last modified date",
			lastChangeBy: "Last change by",
			createJob: "New team",
			editJob: "Basics",
			deleteJob: "Delete",
			basics: "Basics",
			settings: "Create team",
			settingsLabel: "Settings",
			config: "Configuration",
			messageNotSelf: "The parent team cannot be this channel.",
			messageMandatoryInfo: "The team cannot be saved because mandatory information is missing.",
			messageMandatoryInfoConfig: "The team cannot be saved because mandatory information in the team configuration is missing.",
			messageDeleteJobTitle: "Delete team",
			messageDeleteJob: "Are you sure you want to delete this team?",
			messageCreated: "Team created",
			messageUpdated: "Team updated",
			messageDeleted: "Team deleted",
			defaultConfig: "Use standard team configuration",
			errorMandatoryFields: "The team cannot be saved because mandatory information is missing.",
			errorJobExist: "The team already exists.",
			errorJobExistNotification: "This team cannot be saved because the team ID already exists.",
			errorJobFailedLoad: "Error loading {id}"
		},
		jobList: {
			all: "All",
			title: "Team",
			newButton: "New team",
			search: "Search for team or display name",
			brand: "Brand",
			loading: "Loading teams",
			headerTitle: "Title",
			edit: "Edit",
			view: "Show"
		}
	},
	de: {
		jobs: {
			jobId: "Team-ID",
			job: "Team",
			displayName: "Anzeigename",
			lastChange: "Änderungsdatum (last modified)",
			lastChangeBy: "Letzte Änderung von",
			createJob: "Neues Team",
			editJob: "Basics",
			deleteJob: "Löschen",
			basics: "Basics",
			settingsLabel: "Einstellungen",
			settings: "Team erstellen",
			config: "Konfiguration",
			messageNotSelf: "Das übergeordnete Team kann nicht in diesem Team sein.",
			messageMandatoryInfo: "Das Team kann nicht gespeichert werden, weil Pflichtinformationen fehlen.",
			messageMandatoryInfoConfig: "Das Team kann nicht gespeichert werden, weil Pflichtinformationen in der Team-Konfiguration fehlen.",
			messageDeleteJob: "Willst du das Team wirklich löschen?",
			messageDeleteJobTitle: "Team löschen",
			messageCreated: "Team erstellt",
			messageUpdated: "Team aktualisiert",
			messageDeleted: "Team gelöscht",
			defaultConfig: "Standard-Team-Konfiguration nutzen",
			errorMandatoryFields: "Das Team kann nicht gespeichert werden, weil Pflichtinformationen fehlen.",
			errorJobExist: "Die Team-ID existiert bereits.",
			errorJobExistNotification: "Das Team kann nicht gespeichert werden, weil die Team-ID bereits existiert.",
			errorJobFailedLoad: "Fehler beim Laden von {id}"
		},
		jobList: {
			all: "Alle",
			title: "Team",
			newButton: "Neues Team",
			search: "Suchen nach Team oder Anzeigename",
			brand: "Marke",
			loading: "Teams werden geladen",
			headerTitle: "Titel",
			edit: "Bearbeiten",
			view: "Anzeigen"
		}
	}
}, { listEntities: T, deleteEntity: E, postEntity: D, putEntity: O } = b, k = async (e) => T({ params: {
	...e,
	isRootJob: !0
} }), A = async (e) => E(e), j = async (e) => await D(e), M = async (e) => await O(e._id, e), N = () => ({
	_id: "",
	createDate: /* @__PURE__ */ new Date(),
	changeDate: /* @__PURE__ */ new Date(),
	displayName: "",
	job: "",
	jobId: "",
	isDeleted: !1
}), P = /* @__PURE__ */ ((e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
})(/* @__PURE__ */ c({
	__name: "job-list.selector",
	props: {
		modelValue: { default: "" },
		label: { default: void 0 },
		disabled: {
			type: Boolean,
			default: !1
		},
		required: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(c, { emit: _ }) {
		let v = s(() => import("./job-list-DLGHiS3i.js")), { t: y } = g(), b = c, S = _, C = f(!1), w = f(), T = (e) => {
			w.value = e || { displayName: "" }, S("update:modelValue", e?._id), C.value = !1;
		}, E = r(() => b.label ? b.label : y("components.jobSelectorLabel")), D = () => {
			w.value = {
				displayName: "",
				_id: void 0
			}, S("update:modelValue", w.value._id);
		};
		return m(() => b.modelValue, async () => {
			b.modelValue ? w.value = await x(b.modelValue) : D();
		}, { deep: !0 }), u(async () => {
			w.value = await x(b.modelValue);
		}), (r, s) => (d(), a("div", null, [o(p(n), l({
			modelValue: w.value.displayName,
			"onUpdate:modelValue": s[0] ||= (e) => w.value.displayName = e,
			"data-qa-job-input-field": "",
			class: c.required && "required",
			disabled: c.disabled,
			label: E.value,
			"background-color": "white",
			clearable: "",
			outlined: "",
			dense: "",
			readonly: ""
		}, r.$attrs, {
			onClick: s[1] ||= (e) => C.value = !0,
			"onClick:clear": s[2] ||= (e) => T(void 0),
			"onClick:append": s[3] ||= (e) => C.value = !0
		}), {
			append: h(() => [w.value.displayName ? (d(), i(p(t), {
				key: 1,
				name: "clear",
				onClick: D
			})) : (d(), i(p(t), {
				key: 0,
				name: "external-link"
			}))]),
			_: 1
		}, 16, [
			"modelValue",
			"class",
			"disabled",
			"label"
		]), o(p(e), {
			modelValue: C.value,
			"onUpdate:modelValue": s[6] ||= (e) => C.value = e,
			"data-qa-job-modal": "",
			"full-width": "",
			"full-height": "",
			onHide: s[7] ||= (e) => C.value = !1
		}, {
			default: h(() => [o(p(v), {
				dialog: !0,
				"filter-id": w.value._id,
				"is-job-query": !0,
				"show-new-button": !1,
				onClose: s[4] ||= (e) => C.value = !1,
				"onClick:job": T,
				"onBack:modal": s[5] ||= (e) => C.value = !1
			}, null, 8, ["filter-id"])]),
			_: 1
		}, 8, ["modelValue"])]));
	}
}), [["__scopeId", "data-v-ce304869"]]), F = [{
	path: "/job-groups",
	children: [
		{
			path: "",
			name: "job_list",
			component: () => import("./job-list-DLGHiS3i.js"),
			props: (e) => ({
				query: e.query.search,
				brand: e.query.brand
			}),
			meta: { requiredRight: "jobs:navigate" }
		},
		{
			path: "new",
			name: "job_new",
			component: () => import("./job-edit-B-Uv_vck.js"),
			meta: { requiredRight: "jobs:navigate" }
		},
		{
			path: ":id",
			name: "job_detail",
			component: () => import("./job-edit-B-Uv_vck.js"),
			props: (e) => ({
				id: e.params.id,
				backRoute: "/job-groups",
				readOnly: !C("job")
			}),
			meta: { requiredRight: "jobs:navigate" }
		}
	]
}], I = P, L = {
	messages: w,
	routes: F
};
//#endregion
export { _ as BfJobSelector, v as JobGroupModelName, y as JobService, I as default, A as deleteJob, N as getDefaultStateJob, x as getJob, S as getJobs, L as jobModule, k as loadMainJobs, j as postJob, M as putJob };

//# sourceMappingURL=index.es.js.map